/**
 * cn — the className helper used by EVERY component in the app.
 *
 * IT SOLVES TWO PROBLEMS AT ONCE
 *
 * 1) Conditional classes without ugly string concatenation.
 *      cn('rounded-lg', isActive && 'bg-primary-600', isBig ? 'p-6' : 'p-3')
 *    `false`, `undefined` and `null` are ignored, so you never end up with
 *    "rounded-lg false p-3" in your markup.
 *
 * 2) Tailwind conflict resolution — the important one.
 *    Plain joining produces "px-4 px-8", and which wins is undefined; the
 *    browser just takes whichever CSS rule was defined last, not whichever you
 *    passed last. twMerge understands Tailwind and keeps only the LAST of any
 *    conflicting pair, so:
 *      cn('px-4 py-2', 'px-8')  ->  'py-2 px-8'
 *    This is what lets a component set sensible defaults AND let callers
 *    override a single class cleanly:
 *      <Button className="px-8" />   // overrides the default padding, nothing else
 *
 * clsx handles case 1, tailwind-merge handles case 2. Together they are the
 * de-facto standard for building a Tailwind component library.
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
